webpackJsonp([37],{

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(807)
}
var Component = __webpack_require__(52)(
  /* script */
  __webpack_require__(766),
  /* template */
  __webpack_require__(836),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_handy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_datalabels__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_datalabels__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var Chart = __webpack_require__(147);


var COLORS = ['227,108,9', '49,133,155', '95,73,122', '118,146,60', '149,55,52', '54,96,146', '23,54,93', '73,68,41'];

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      reportChip: ['Last Month', 'Last Week', 'Yesterday', 'Today', 'This Week', 'This Month', 'Period'],
      fromDate: null,
      toDate: null,
      trendFrom: null,
      trendTo: null,
      fromDt: null,
      toDt: null,
      enableChip: '',
      handy: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a,
      config: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a,
      lAtt: {
        tot_present: 0,
        tot_wo: 0,
        tot_holiday: 0,
        tot_ot: 0,
        tot_leave: 0,
        tot_absent: 0,
        tot_pend: 0,
        tot_staff: 0,
        attAve: 0
      },
      dlgPeriodFrom: false,
      dlgPeriodTo: false,
      periodFrom: '',
      periodTo: '',
      aDay: false,
      tmpChart: [],
      tmpChart2: [],
      enableTrend: false,
      waterConsType: '',
      // water sources
      domWatList: [],
      waterConsTypeList: [],
      waterQualParamList: [],
      waterQualType: '',
      waterQualiltyType: '',
      watQualHead: [], // constructed dynamically
      watList: [],
      consumptionChip: ['Domestic', 'Recycled/Treated'],
      choosenType: 'Domestic',
      tankerVal: 0,
      receivedVal: 0,
      consumedVal: 0,
      powCons: '',
      genCons: '',
      diCons: '',
      diStock: '',
      metricCat: [],
      lDailyUpdateAttach: {
        fileUrls: [],
        files: []
      },
      showUploadImage: false,
      photoCatChips: [],
      showSummary: false,
      repHeadSm: [{ text: 'Role [Headcount]', value: 'staff_role' }, { text: 'Present', value: 'tot_present', class: 'pa-0' }, { text: 'Weekoff', value: 'tot_wo' }, { text: 'Holiday', value: 'tot_holiday' }, { text: 'Standby/OT', value: 'tot_ot' }, { text: 'Leave', value: 'tot_leave' }, { text: 'Absent', value: 'tot_absent' }, { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }],
      repHead: [{ text: 'Role', value: 'staff_role' }, { text: 'Present', value: 'tot_present', class: 'pa-0' }, { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }],
      attReport: [],
      // common chip for all summary trend
      trendChip: ['Last 1 hr', '6 hrs', '12 hrs', 'A day'],
      waterConsTrendChip: ['6 hrs', '12 hrs', 'A day'],
      enableTrendChip: '',
      // water quality summary
      qualityTrendOverADay: false,
      waterTypeLebel: [],
      fromTime: null,
      toTime: null,
      // water lvl summary
      storageNmListWithWaterLvl: [],
      selectedStorageNmWithWaterLvl: [],
      lvlTrendOverADay: false,
      watTankBattery: null,
      // water cons summary
      storageNmListWithWaterCons: [],
      selectedStorageNmWithWaterCons: [],
      consTrendOverADay: false,
      // power cons trend
      showPowerConstrendOverADay: false,
      // Hygiene
      hygList: [],
      hygCats: {},
      sanHeads: [{ text: 'Category', value: 'check_cat' }, { text: 'Description', value: 'check_desc' }, { text: 'Remark', value: 'remark' }, { text: '', value: 'check_value' }],
      sanList: [],
      showSanityChecks: false,
      lSan: {},
      lWaste: {},
      // incident
      incidentList: [],
      incidentTypes: {},
      lIncident: [],
      lInc: {},
      incHeads: [{ text: 'Type', value: 'incident_type' }, { text: 'Class', value: 'incident_class' }, { text: 'Description', value: 'incident_desc' }, { text: 'Incident Date', value: 'incident_on' }],
      showIncident: false,
      // remark
      lReport: {},
      showRemark: false,
      AttHeads: [{ text: 'Date', value: 'c_date', width: '150px' }, { text: 'Remark', value: 'remark_attendance' }],
      // common
      nodata: false,
      timer: '',
      secTimer: '',
      sectionList: ['bp_water', 'bp_power', 'bp_sanity', 'bp_attendance'],
      curSec: 0,
      isAutoRef: false
    };
  },
  created: function created() {
    this.loadCustomMetricCat();
    this.loadWaterConsType();
  },
  mounted: function mounted() {
    var curDate = new Date();
    this.periodFrom = this.periodTo = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(curDate);
    this.loadDashboardBasedOnPeriod('Yesterday');
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.secTimer);
  },

  computed: {
    chosenPeriod: function chosenPeriod() {
      return ' [' + (this.enableChip === 'Today' || this.enableChip === 'Yesterday' ? __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(this.fromDate) : __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(this.fromDate) + ' to ' + __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(this.toDate)) + ']';
    }
  },
  methods: {
    msg: function msg(m) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (type === 0) {
        this.sbarCol = 'error';
      } else if (type === 1) {
        this.sbarCol = 'success';
      } else {
        this.sbarCol = 'info';
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    loadDailyDashboardSummary: function loadDailyDashboardSummary() {
      this.loadCustomMetricCat();
      this.loadWaterConsType();
      this.loadAttChart();
      this.loadWaterLevelChart();
      this.loadWaterConsChart();
      this.loadWaterSources();
      this.loadWaterQualChart();
      this.loadPowerConsChart();
      this.loadDieselConsChart();
      this.loadWasteChart();
      this.loadOtherCustomMetricChart();
      this.loadPhotoCat();
      this.loadFacDailyUpdateAttachment();
      this.loadRemark();
      this.loadHygieneCat();
      this.loadIncidentClass();
    },
    loadDashboardBasedOnPeriod: function loadDashboardBasedOnPeriod() {
      var curChip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.enableChip;

      // find the period based on selection
      this.enableChip = curChip;
      this.fromDate = this.toDate = null;
      var curDate = new Date();
      if (curChip === 'Today') {
        this.fromDate = this.toDate = curDate;
        this.aDay = true;
      } else if (curChip === 'Yesterday') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 1));
        this.toDate = this.fromDate;
        this.aDay = true;
      } else if (curChip === 'This Week') {
        this.toDate = new Date();
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - (curDate.getDay() - 1)));
        this.aDay = false;
      } else if (curChip === 'Last Week') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 7 - (curDate.getDay() - 1)));
        this.toDate = new Date(curDate.setDate(curDate.getDate() + 6));
        this.aDay = false;
      } else if (curChip === 'This Month') {
        this.fromDate = new Date(curDate.getFullYear(), curDate.getMonth(), 1);
        this.toDate = curDate;
        this.aDay = false;
      } else if (curChip === 'Last Month') {
        curDate.setDate(1);
        this.fromDate = new Date(curDate.setMonth(curDate.getMonth() - 1));
        this.toDate = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0);
        this.aDay = false;
      } else {
        if (this.periodTo < this.periodFrom) {
          this.msg('From date has to be less than or equal to To date', 0);
          return;
        }
        this.fromDate = new Date(this.periodFrom);
        this.toDate = new Date(this.periodTo);
        this.aDay = this.periodFrom === this.periodTo;
      }
      // derive the trend
      if (this.aDay) {
        this.trendFrom = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), 1);
        this.trendTo = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth() + 1, 0);
      } else {
        this.trendFrom = this.fromDate;
        this.trendTo = this.toDate;
      }
      // convert the period into required format
      this.fromDate = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.fromDate);
      this.toDate = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.toDate);
      this.trendFrom = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendFrom) + ' 00:00:00';
      this.trendTo = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendTo) + ' 23:59:59';
      // refresh the dashboard
      this.loadDailyDashboardSummary();
    },
    loadAttChart: function loadAttChart() {
      var _this = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.trendFrom,
          to_dt: this.trendTo,
          group_by: 'date',
          is_billable: 1
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getAttendanceRep/', qry).then(function (response) {
        var dtLbl = []; // x-axis dates
        var avgVal = [];
        var totPr = 0;
        var totFL = 0;
        var totLeave = 0;
        var totWO = 0;
        var totOT = 0;
        var totPend = 0;
        var totStaff = 0;
        var totHoliday = 0;
        // trend chart
        for (var i = 0; i < response.data.length; i++) {
          // pre-processing
          response.data[i].tot_present = response.data[i].tot_present + response.data[i].tot_hd / 2;
          response.data[i].tot_absent = response.data[i].tot_absent + response.data[i].tot_hd / 2;
          // for graph
          dtLbl[i] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(response.data[i].att_dt);
          avgVal[i] = Math.round((response.data[i].tot_present + response.data[i].tot_wo + response.data[i].tot_ot + response.data[i].tot_hd) / response.data[i].total_staff * 100);
          // for dashboard summary
          if (response.data[i].total_staff) {
            totStaff += response.data[i].total_staff;
          }
          if (response.data[i].tot_present) {
            totPr += response.data[i].tot_present;
          }
          if (response.data[i].tot_absent) {
            totFL += response.data[i].tot_absent;
          }
          if (response.data[i].tot_leave) {
            totLeave += response.data[i].tot_leave;
          }
          if (response.data[i].tot_wo) {
            totWO += response.data[i].tot_wo;
          }
          if (response.data[i].tot_ot) {
            totOT += response.data[i].tot_ot;
          }
          if (response.data[i].tot_holiday) {
            totHoliday += response.data[i].tot_holiday;
          }
          if (response.data[i].tot_pend) {
            totPend += response.data[i].tot_pend;
          }
        }
        // summary
        if (_this.aDay) {
          // find out the values of chosen day
          var didx = response.data.findIndex(function (rec) {
            return __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(rec.att_dt) === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this.fromDate);
          });
          if (didx >= 0) {
            _this.lAtt.tot_staff = response.data[didx].total_staff;
            _this.lAtt.tot_present = response.data[didx].tot_present;
            _this.lAtt.tot_leave = response.data[didx].tot_leave;
            _this.lAtt.tot_absent = response.data[didx].tot_absent;
            _this.lAtt.tot_wo = response.data[didx].tot_wo;
            _this.lAtt.tot_holiday = response.data[didx].tot_holiday;
            _this.lAtt.tot_ot = response.data[didx].tot_ot;
            _this.lAtt.tot_pend = response.data[didx].tot_pend;
            _this.lAtt.attAve = Math.round((_this.lAtt.tot_present + _this.lAtt.tot_wo + _this.lAtt.tot_ot + _this.lAtt.tot_holiday) / _this.lAtt.tot_staff * 100);
          }
        } else {
          _this.lAtt.tot_staff = totStaff;
          _this.lAtt.tot_present = totPr;
          _this.lAtt.tot_absent = totFL;
          _this.lAtt.tot_leave = totLeave;
          _this.lAtt.tot_wo = totWO;
          _this.lAtt.tot_holiday = totHoliday;
          _this.lAtt.tot_ot = totOT;
          _this.lAtt.tot_pend = totPend;
          _this.lAtt.attAve = Math.round((totPr + totWO + totOT + totHoliday) / totStaff * 100);
        }
        // reset for next date
        var dsets = [];
        dsets[0] = {
          label: 'Attendance %',
          borderColor: 'rgba(0,0,255,0.8)',
          data: avgVal,
          fill: false
        };
        if (_this.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_attend').innerHTML = '<canvas id="chart_attend"></canvas>';
          var canvas = document.getElementById('chart_attend');
          var ctx = canvas.getContext('2d');
          _this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }
      }).catch(function (err) {
        _this.msg(err, 0);
      });
    },
    showAttendanceSummary: function showAttendanceSummary() {
      var _this2 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.aDay ? this.fromDate : this.trendFrom,
          to_dt: this.aDay ? this.fromDate : this.trendTo,
          group_by: 'role',
          is_billable: 1
        }
      };
      this.attReport = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getAttendanceRep/', qry).then(function (response) {
        _this2.attReport = response.data;
        // calculate few fields
        _this2.attReport.forEach(function (rec) {
          rec.staff_role = rec.staff_role + ' [' + rec.role_count + ']';
          rec.tot_present = rec.tot_present + rec.tot_hd / 2;
          rec.tot_absent = rec.tot_absent + rec.tot_hd / 2;
        });
        _this2.showSummary = true;
      }).catch(function (err) {
        _this2.msg(err.response.data, 0);
      });
    },
    loadWaterLevelChart: function loadWaterLevelChart() {
      var _this3 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWaterLevelChartDetailsByCommId/', qry).then(function (response) {
        // retrive data from db and construct chart
        var resObj = response.data;
        var watTypeLbl = [];
        var levelVal = {};
        var gw = 0;
        var dtLbl = []; // for trend chart
        var levelAvgVal = {};
        var waterLvlKl = {};
        var gd = 0;
        var idx = 0;
        for (var i = 0; i < resObj.length; i++) {
          watTypeLbl[gw] = resObj[i].storage_nm;
          levelVal[gw] = [];
          levelAvgVal[gw] = [];
          idx = gw++;
          var lvl = resObj[i].levels;
          for (var d = 0; d < lvl.length; d++) {
            if (lvl[d].water_level === '') {
              lvl[d].water_level = 0;
            }
            var didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(lvl[d].c_date));
            if (didx < 0 && lvl[d].c_date) {
              dtLbl[gd] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(lvl[d].c_date);
              didx = gd++;
            }
            if (_this3.aDay) {
              if (dtLbl[didx] === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(_this3.fromDate)) {
                if (lvl[d].water_level) {
                  levelVal[idx][i] = lvl[d].water_level; // show specific data for the day in first graph in case of single date
                }
                if (lvl[d].water_level_kl) {
                  waterLvlKl[i] = lvl[d].water_level_kl + ' KL';
                }
              }
            } else {
              if (!levelVal[idx][i]) {
                levelVal[idx][i] = 0;
              }
              levelVal[idx][i] += Number(lvl[d].water_level);
            }
            if (!levelAvgVal[idx][didx]) {
              levelAvgVal[idx][didx] = 0;
            }
            levelAvgVal[idx][didx] = Number(lvl[d].water_level);
          }
          if (!_this3.aDay) {
            levelVal[idx][i] /= lvl.length; // show average in first graph in case of period
            levelVal[idx][i] = levelVal[idx][i].toFixed(0);
          }
        }
        // chart 1
        // data set
        var value = [];
        for (i = 0; i < watTypeLbl.length; i++) {
          value.push(levelVal[i][i]);
        }
        // clear the content if any
        document.getElementById('div_watlvl').innerHTML = '<canvas id="chart_watlvl"></canvas>';
        var canvas = document.getElementById('chart_watlvl');
        canvas.height = watTypeLbl.length > 2 ? watTypeLbl.length * 30 : watTypeLbl.length * 50;
        var ctx = canvas.getContext('2d');
        _this3.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: watTypeLbl,
            datasets: [{
              backgroundColor: 'rgba(' + COLORS[1] + ',0.7)',
              data: value,
              fill: true
            }]
          },
          options: {
            tooltips: { enabled: false },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  min: 0
                }
              }]
            },
            hover: {
              animationDuration: 0
            },
            plugins: {
              datalabels: {
                formatter: function formatter(value) {
                  return value + '%' || '';
                },
                color: '#ffffff'
              }
            }
          }
        });

        // chart 2
        var dsets2 = [];
        for (i = 0; i < watTypeLbl.length; i++) {
          dsets2[i] = {
            label: watTypeLbl[i] + ' (%)',
            backgroundColor: 'rgba(' + COLORS[1] + ',0.1)',
            borderColor: 'rgba(' + COLORS[i] + ',1)',
            data: levelAvgVal[i],
            fill: true
          };
        }
        if (_this3.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_watlvltrend').innerHTML = '<canvas id="chart_watlvltrend"></canvas>';
          canvas = document.getElementById('chart_watlvltrend');
          var ctx2 = canvas.getContext('2d');

          _this3.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }
        _this3.$forceUpdate();
      }).catch(function (err) {
        _this3.msg(err, 0);
      });
    },
    loadWaterConsType: function loadWaterConsType() {
      var _this4 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWaterStorageByCommId/', qry).then(function (response) {
        _this4.waterConsTypeList = response.data.map(function (rec) {
          return rec.storage_nm;
        });
        _this4.waterConsType = _this4.waterConsTypeList[0];
        // water level trend over a day
        _this4.storageNmListWithWaterLvl = response.data.filter(function (rec) {
          return rec.is_level_checked === 1;
        });
        if (_this4.storageNmListWithWaterLvl.length > 0) {
          _this4.selectedStorageNmWithWaterLvl = _this4.storageNmListWithWaterLvl[0].storage_id;
        }
        // water consumption trend over a day
        _this4.storageNmListWithWaterCons = response.data.filter(function (rec) {
          return rec.is_receipt_checked === 1 || rec.is_cons_checked === 1;
        });
        if (_this4.storageNmListWithWaterCons.length > 0) {
          _this4.selectedStorageNmWithWaterCons = _this4.storageNmListWithWaterCons[0].storage_id;
        }
      }).catch(function (err) {
        _this4.msg(err.response.data, true);
      });
    },
    loadWaterConsChart: function loadWaterConsChart() {
      var _this5 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.trendFrom,
          to_dt: this.trendTo,
          comingFrom: 'Facdash',
          water_cat: this.choosenType
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWaterConsChartDetailsByCommId/', qry).then(function (response) {
        // retrive data from db and construct chart
        var resObj = response.data;
        var watTypeLbl = [];
        var recVal = {};
        var dtLbl = []; // for trend chart
        var recAvgVal = {};
        var didx = 0;
        var widx = 0;
        var custWatType = _this5.waterConsType;
        var modeLbl = ['Received (KL)', 'Consumed (KL)'];
        recVal[0] = [];
        recVal[1] = [];
        recAvgVal[0] = [];
        recAvgVal[1] = [];
        _this5.tankerVal = 0;
        _this5.receivedVal = 0;
        _this5.consumedVal = 0;
        for (var r = 0; r < resObj.length; r++) {
          var cons = resObj[r].cons;
          for (var d = 0; d < cons.length; d++) {
            didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(cons[d].c_date));
            if (didx < 0 && cons[d].c_date) {
              didx = dtLbl.length;
              dtLbl[didx] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(cons[d].c_date);
            }
            widx = watTypeLbl.indexOf(resObj[r].storage_nm.substring(0, 10));
            if (widx < 0) {
              widx = watTypeLbl.length;
              watTypeLbl[widx] = resObj[r].storage_nm.substring(0, 10);
            }
            if (_this5.aDay) {
              // show specefic data for the day in first graph in case of single date
              if (dtLbl[didx] === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this5.fromDate)) {
                if (!recVal[0][widx]) {
                  recVal[0][widx] = 0;
                }
                if (cons[d].water_receipt) {
                  _this5.receivedVal += cons[d].water_receipt;
                }
                recVal[0][widx] += cons[d].water_cons;
              }
            } else {
              if (!recVal[0][widx]) {
                recVal[0][widx] = 0;
              }
              if (cons[d].water_receipt) {
                _this5.receivedVal += cons[d].water_receipt;
              }
              recVal[0][widx] += Number(cons[d].water_cons);
              recVal[1][widx] += Number(cons[d].water_receipt);
            }
            // worry about trend of only user chosen water type
            if (custWatType === resObj[r].storage_nm) {
              if (recAvgVal[0][didx] === undefined || recAvgVal[1][didx] === undefined) {
                recAvgVal[0][didx] = 0;
                recAvgVal[1][didx] = 0;
              }
              recAvgVal[0][didx] += Number(cons[d].water_receipt);
              recAvgVal[1][didx] += Number(cons[d].water_cons);
            }
          }
        }
        // to do: when automated for mulitple timestamps on the same day
        // chart 1 (water receipt and cons)
        // data set
        var dsets = [];
        for (var j = 0; j < recVal[0].length; j++) {
          recVal[0][j] = recVal[0][j] > 0 ? recVal[0][j].toFixed(2) : 0;
          _this5.consumedVal += Number(recVal[0][j]);
        }
        dsets[0] = {
          label: modeLbl[1],
          backgroundColor: 'rgba(' + COLORS[4] + ',0.7)',
          borderColor: 'rgba(' + COLORS[4] + ',1)',
          data: recVal[0],
          fill: true
          // clear the content if any
        };document.getElementById('div_watcons').innerHTML = '<canvas id="chart_watcons"></canvas>';
        var canvas = document.getElementById('chart_watcons');
        canvas.height = watTypeLbl.length > 4 ? watTypeLbl.length * 30 : watTypeLbl.length * 50;
        var ctx = canvas.getContext('2d');
        _this5.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: watTypeLbl,
            datasets: dsets
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function formatter(value) {
                  return value > 0 ? value + ' KL' : '';
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          }
        });
        // chart 2 (trend)
        var dsets2 = [];
        for (var i = 0; i < modeLbl.length; i++) {
          for (j = 0; j < recAvgVal[i].length; j++) {
            recAvgVal[i][j] = recAvgVal[i][j] > 0 ? recAvgVal[i][j].toFixed(2) : 0;
          }
          dsets2[i] = {
            label: modeLbl[i],
            backgroundColor: 'rgba(' + COLORS[i === 0 ? i + 2 : i + 3] + ',0.1)',
            borderColor: 'rgba(' + COLORS[i === 0 ? i + 2 : i + 3] + ',1)',
            data: recAvgVal[i],
            fill: false
          };
        }
        if (_this5.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_watconstrend').innerHTML = '<canvas id="chart_watconstrend"></canvas>';
          canvas = document.getElementById('chart_watconstrend');
          var ctx2 = canvas.getContext('2d');
          _this5.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }
        _this5.$forceUpdate();
      }).catch(function (err) {
        _this5.msg(err, 0);
      });
    },
    loadWaterSources: function loadWaterSources() {
      var _this6 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          c_date: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.fromDate),
          from_dt: this.fromDate,
          to_dt: this.toDate
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWaterSourcesByCommIdAndcDate/', qry).then(function (response) {
        if (response.data.length > 0) {
          _this6.domWatList = response.data;
        }
        _this6.$forceUpdate();
      }).catch(function (err) {
        _this6.msg(err, 0);
      });
    },
    loadWaterConsumptionBasedonChip: function loadWaterConsumptionBasedonChip(curChip) {
      this.choosenType = curChip;
      this.loadWaterConsChart();
    },
    loadWaterQualChart: function loadWaterQualChart() {
      var _this7 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getDailyWaterQualityByCommId/', qry).then(function (response) {
        // retrive data from db and construct chart
        var resObj = response.data;
        var paramLbl = [];
        var paramId = [];
        var paramUoM = [];
        var watTypeLbl = [];
        var qualVal = {};
        var stdValMin = [];
        var stdValMax = [];
        var dtLbl = []; // for trend chart
        var avgWaterLbl = [];
        var qualAvgVal = {};
        var didx = 0;
        var widx = 0;
        var pidx = 0;
        var apidx = 0;
        var dtIdx = 1;
        var x = 0;
        var custParamName = _this7.waterQualType;
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date));

          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length;
            dtLbl[didx] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date);
          }

          widx = watTypeLbl.indexOf(resObj[r].water_type);
          if (widx < 0) {
            widx = watTypeLbl.length;
            watTypeLbl[widx] = resObj[r].water_type;
            qualVal[widx] = [];
          }

          pidx = paramId.indexOf(resObj[r].param_id);
          if (pidx < 0) {
            pidx = paramId.length;
            paramId[pidx] = resObj[r].param_id;
            paramLbl[pidx] = resObj[r].param_name;
            qualAvgVal[pidx] = [];
          }
          if (_this7.aDay) {
            // show specefic data for the day in first graph in case of single date - overwrite to latest value if multiple log is found
            if (dtLbl[didx] === _this7.fromDate) {
              qualVal[widx][pidx] = Number(resObj[r].val);
            }
          } else {
            if (qualVal[widx][pidx] === undefined) {
              qualVal[widx][pidx] = 0;
            }
            qualVal[widx][pidx] += Number(resObj[r].val);
          }
          paramUoM[pidx] = resObj[r].uom;
          stdValMin[pidx] = Number(resObj[r].std_val_min);
          stdValMax[pidx] = Number(resObj[r].std_val_max);

          // worry about trend of only user chosen parameter
          if (custParamName === resObj[r].param_name) {
            apidx = avgWaterLbl.indexOf(resObj[r].water_type);
            if (apidx < 0) {
              apidx = avgWaterLbl.length;
              avgWaterLbl[apidx] = resObj[r].water_type;
              qualAvgVal[apidx] = [];
            }

            qualAvgVal[apidx][didx] = Number(resObj[r].val);
          }
        }
        // find ave
        if (!_this7.aDay) {
          for (var i = 0; i < watTypeLbl.length; i++) {
            for (var j = 0; j < paramLbl.length; j++) {
              if (qualVal[i][j] && qualVal[i][j] !== '  ') {
                x = resObj.filter(function (rec) {
                  return rec.param_name === paramLbl[j];
                }).length;
                if (x > 1) {
                  qualVal[i][j] /= x;
                }
                qualVal[i][j] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(qualVal[i][j]) || qualVal[i][j] > 50 ? qualVal[i][j].toFixed(0) : qualVal[i][j].toFixed(1);
              }
            }
          }
        }
        // chart 1
        _this7.watQualHead = [{ text: 'PARAM', value: 'param_name', class: 'grey darken-1 white--text text-xs-center' }];
        // params
        _this7.waterQualParamList = paramLbl;
        if (!_this7.waterQualType) {
          _this7.waterQualType = _this7.waterQualParamList[0];
        }
        _this7.watList = [];
        var minMax = '';
        for (i = 0; i < paramLbl.length; i++) {
          if (stdValMin[i] && stdValMax[i]) {
            minMax = stdValMin[i] + ' to ' + stdValMax[i];
          } else if (stdValMin[i]) {
            minMax = 'min ' + stdValMin[i];
          } else {
            minMax = 'max ' + stdValMax[i];
          }
          _this7.watList.push({
            param_name: paramLbl[i],
            param_value: '(' + paramUoM[i] + ') [' + minMax + ']',
            std_val_min: stdValMin[i],
            std_val_max: stdValMax[i],
            waterQualTypeValue: []
          });
        }
        // construct table headers dynamically
        for (i = 0; i < watTypeLbl.length; i++) {
          _this7.watQualHead.splice(dtIdx++, 0, {
            text: watTypeLbl[i] === 'SWIMMING POOL' ? 'S. POOL' : watTypeLbl[i], value: watTypeLbl[i], class: 'pl-2 pr-0 text-xs-center white--text ccolor' + (i + 1)
          });
        }
        // construct value table for each parameter

        for (i = 0; i < paramLbl.length; i++) {
          for (j = 0; j < watTypeLbl.length; j++) {
            _this7.watList[i].waterQualTypeValue.push({
              val: qualVal[j][i] || ''
            });
          }
        }
        dtLbl.forEach(function (rec) {
          if (rec.length === 0) {
            qualAvgVal = {};
          }
        });
        _this7.waterTypeLebel = watTypeLbl;
        // chart 2
        var watColor = 0;
        var dsets2 = [];
        for (i = 0; i < avgWaterLbl.length; i++) {
          watColor = watTypeLbl.indexOf(avgWaterLbl[i]);
          dsets2[i] = {
            label: avgWaterLbl[i],
            backgroundColor: 'rgba(' + COLORS[watColor] + ', 0.1)',
            borderColor: 'rgba(' + COLORS[watColor] + ', 1)',
            data: qualAvgVal[i],
            fill: false
          };
        }
        if (_this7.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_watqualtrend').innerHTML = '<canvas id="chart_watqualtrend"></canvas>';
          var canvas = document.getElementById('chart_watqualtrend');
          var ctx2 = canvas.getContext('2d');
          _this7.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }
      }).catch(function (err) {
        _this7.msg(err, 0);
      });
    },
    loadPowerConsChart: function loadPowerConsChart() {
      var _this8 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getPowerConsChartDetailsByCommId/', qry).then(function (response) {
        var resObjPow = response.data.filter(function (rec) {
          return rec.power_unit_cons !== -1;
        });
        var resObjGen = response.data.filter(function (rec) {
          return rec.genset_unit_cons !== -1;
        });
        var dtLbl = []; // for trend chart
        var recTrendVal = {};
        var recVal = 0;
        recTrendVal[0] = [];
        recTrendVal[1] = [];
        recTrendVal[2] = [];
        var powUnits = 0;
        var genUnits = 0;
        var totPowUnits = 0;
        var totGenUnits = 0;
        for (var r = 0; r < resObjPow.length; r++) {
          dtLbl[r] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObjPow[r].c_date);
          recTrendVal[0][r] = Number(resObjPow[r].power_unit_cons);

          if (_this8.aDay) {
            // show specefic data for the day in section 1
            if (dtLbl[r] === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this8.fromDate)) {
              powUnits = Number(resObjPow[r].power_unit_cons);
            }
          } else {
            recVal = recVal + Number(resObjPow[r].power_unit_cons);
            totPowUnits = totPowUnits + Number(resObjPow[r].power_unit_cons);
          }
        } // for every rec
        // genset
        for (r = 0; r < resObjGen.length; r++) {
          dtLbl[r] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObjGen[r].c_date);
          recTrendVal[1][r] = Number(resObjGen[r].genset_unit_cons);
          if (_this8.aDay) {
            // show specefic data for the day in section 1
            if (dtLbl[r] === _this8.fromDate) {
              genUnits = Number(resObjGen[r].genset_unit_cons);
            }
          } else {
            recVal = recVal + Number(resObjGen[r].genset_unit_cons);
            totGenUnits = totGenUnits + Number(resObjGen[r].genset_unit_cons);
          }
        } // for every rec
        if (_this8.aDay) {
          _this8.powCons = powUnits;
          _this8.genCons = genUnits;
        } else {
          _this8.powCons = totPowUnits;
          _this8.genCons = totGenUnits;
        }
        if (_this8.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_powconstrend').innerHTML = '<canvas id="chart_powconstrend"></canvas>';
          var canvas = document.getElementById('chart_powconstrend');
          var ctx = canvas.getContext('2d');
          _this8.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: [{
                label: 'Electricity Board (units)',
                backgroundColor: 'rgba(' + COLORS[2] + ',0.4)',
                borderColor: 'rgba(' + COLORS[2] + ',1)',
                data: recTrendVal[0],
                fill: true
              }, {
                label: 'Genset (units)',
                backgroundColor: 'rgba(' + COLORS[4] + ',0.4)',
                borderColor: 'rgba(' + COLORS[4] + ',1)',
                data: recTrendVal[1],
                fill: false
              }]
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }
        _this8.$forceUpdate();
      }).catch(function (err) {
        _this8.msg(err, 0);
      });
    },
    loadDieselConsChart: function loadDieselConsChart() {
      var _this9 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getPowerGensetByCommIdAndcDate/', qry).then(function (response) {
        var resObj = response.data;
        var modeLbl = ['Level (%)', 'Purchased (ltr)', 'Stock (ltr)'];
        var genLbl = [];
        var levelVal = {};
        var dtLbl = []; // for trend chart
        var recAvgVal = {};
        var didx = 0;
        var gidx = 0;

        var purVal = 0;
        var stkVal = 0;
        levelVal[0] = [];
        levelVal[1] = [];
        recAvgVal[0] = [];
        recAvgVal[1] = [];
        recAvgVal[2] = [];
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date));
          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length;
            dtLbl[didx] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date);
          }

          gidx = genLbl.indexOf(resObj[r].genset_nm);
          if (gidx < 0) {
            gidx = genLbl.length;
            genLbl[gidx] = resObj[r].genset_nm;
            levelVal[0][gidx] = 0;
            levelVal[1][gidx] = 0;
          }

          if (_this9.aDay) {
            // show specefic data for the day in section 1 (badge)
            if (dtLbl[didx] === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this9.fromDate)) {
              levelVal[0][gidx] = Number(resObj[r].level);
              purVal += Number(resObj[r].purchased);
              stkVal += Number(resObj[r].stock);
            }
          } else {
            levelVal[0][gidx] += Number(resObj[r].level);
            purVal += Number(resObj[r].purchased);
            stkVal += Number(resObj[r].stock);
          }

          if (recAvgVal[0][didx] === undefined || recAvgVal[1][didx] === undefined || recAvgVal[2][didx] === undefined) {
            recAvgVal[0][didx] = 0;
            recAvgVal[1][didx] = 0;
            recAvgVal[2][didx] = 0;
          }
          recAvgVal[0][didx] += Number(resObj[r].level); // total of all genset, average found later
          recAvgVal[1][didx] += Number(resObj[r].purchased);
          recAvgVal[2][didx] += Number(resObj[r].stock);
        } // for every rec
        // find ave
        if (!_this9.aDay) {
          // ave for level and stock only
          for (var i = 0; i < genLbl.length; i++) {
            levelVal[0][i] /= dtLbl.length;
            levelVal[0][i] = levelVal[0][i].toFixed(0);
          }
          stkVal /= dtLbl.length;
          stkVal = stkVal.toFixed(0);
        }
        // average for level in second graph
        for (i = 0; i < dtLbl.length; i++) {
          recAvgVal[0][i] /= genLbl.length;
          recAvgVal[0][i] = recAvgVal[0][i].toFixed(0);
        }
        dtLbl.forEach(function (rec) {
          if (rec.length <= 0) {
            recAvgVal = {};
          }
        });
        // section 1
        // 1. cons
        _this9.diCons = purVal;
        _this9.diStock = stkVal;

        // 2. level
        // data set
        // clear the content if any
        document.getElementById('div_dicons').innerHTML = '<canvas id="chart_dicons"></canvas>';
        var canvas = document.getElementById('chart_dicons');
        var ctx = canvas.getContext('2d');
        _this9.tmpChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: genLbl,
            datasets: [{
              label: modeLbl[0],
              backgroundColor: 'rgba(' + COLORS[3] + ',0.7)',
              borderColor: 'rgba(' + COLORS[3] + ',1)',
              data: levelVal[0],
              fill: true
            }]
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function formatter(value) {
                  return value ? value + ' %' : '';
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          }
        });
        // chart 2
        if (_this9.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_diconstrend').innerHTML = '<canvas id="chart_diconstrend"></canvas>';
          canvas = document.getElementById('chart_diconstrend');
          var ctx2 = canvas.getContext('2d');
          _this9.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: [{
                label: modeLbl[0],
                backgroundColor: 'rgba(' + COLORS[3] + ',0.4)',
                borderColor: 'rgba(' + COLORS[3] + ',1)',
                data: recAvgVal[0],
                fill: true
              }, {
                label: modeLbl[1],
                backgroundColor: 'rgba(' + COLORS[2] + ',0.4)',
                borderColor: 'rgba(' + COLORS[2] + ',1)',
                data: recAvgVal[1],
                fill: false
              }, {
                label: modeLbl[2],
                backgroundColor: 'rgba(' + COLORS[4] + ',0.4)',
                borderColor: 'rgba(' + COLORS[4] + ',1)',
                data: recAvgVal[2],
                fill: false
              }]
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }
      }).catch(function (err) {
        _this9.msg(err, 0);
      });
    },
    loadWasteChart: function loadWasteChart() {
      var _this10 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWasteByCommIdAndcDate/', qry).then(function (response) {
        _this10.lWaste = response.data.filter(function (rec) {
          return __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(rec.c_date) === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this10.fromDate);
        });
        var resObj = response.data;
        var wasteTypeLbl = [];
        var recVal = {};
        var dtLbl = []; // for trend chart
        var recAvgVal = {};
        var didx = 0;
        var widx = 0;

        recVal[0] = [];
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date));

          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length;
            dtLbl[didx] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date);
          }

          widx = wasteTypeLbl.indexOf(resObj[r].waste_type);
          if (widx < 0) {
            widx = wasteTypeLbl.length;
            wasteTypeLbl[widx] = resObj[r].waste_type;
            recVal[widx] = [];
            recAvgVal[widx] = [];
          }
          if (_this10.aDay) {
            // show specefic data for the day in first graph in case of single date
            if (dtLbl[didx] === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this10.fromDate)) {
              recVal[widx][0] = resObj[r].kgs;
            }
          } else {
            if (recVal[widx][0] === undefined) {
              recVal[widx][0] = 0;
            }
            recVal[widx][0] += Number(resObj[r].kgs);
          }
          // for trend
          if (recAvgVal[widx][didx] === undefined) {
            recAvgVal[widx][didx] = 0;
          }
          recAvgVal[widx][didx] += resObj[r].kgs;
        } // for every rec
        // chart 1
        // data set
        var dsets = [];
        var lColor = ['0,255,0', '0,0,255', '255,0,0'];
        for (var i = 0; i < wasteTypeLbl.length; i++) {
          dsets[i] = {
            label: wasteTypeLbl[i] + ' (kg)',
            backgroundColor: 'rgba(' + lColor[i] + ',0.4)',
            borderColor: 'rgba(' + lColor[i] + ',1)',
            data: recVal[i],
            fill: true
          };
        }
        // clear the content if any
        document.getElementById('div_waste').innerHTML = '<canvas id="chart_waste"></canvas>';
        var canvas = document.getElementById('chart_waste');
        var ctx = canvas.getContext('2d');
        _this10.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: ['Wastage (kg)'],
            datasets: dsets
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function formatter(value) {
                  return value + ' kg';
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  min: 0
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        });

        // chart 2
        var dsets2 = [];
        for (i = 0; i < wasteTypeLbl.length; i++) {
          dsets2[i] = {
            label: wasteTypeLbl[i] + ' (kg)',
            backgroundColor: 'rgba(' + lColor[i] + ',0.1)',
            borderColor: 'rgba(' + lColor[i] + ',1)',
            data: recAvgVal[i],
            fill: false
          };
        }
        if (_this10.enableTrend === true) {
          // clear the content if any
          document.getElementById('div_wastetrend').innerHTML = '<canvas id="chart_wastetrend"></canvas>';
          canvas = document.getElementById('chart_wastetrend');
          var ctx2 = canvas.getContext('2d');
          _this10.tmpChart2 = new Chart(ctx2, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets2
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }
      }).catch(function (err) {
        _this10.msg(err, 0);
      });
    },
    loadCustomMetricCat: function loadCustomMetricCat() {
      var _this11 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getCusMetByCommId/', qry).then(function (response) {
        _this11.metricCat = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.unique(response.data.map(function (rec) {
          return rec.metric_cat;
        }));
      }).catch(function (err) {
        _this11.msg(err.response.data, true);
        _this11.metricCat = [];
      });
    },
    loadOtherCustomMetricChart: function loadOtherCustomMetricChart() {
      var _this12 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getMetricByCommId/', qry).then(function (response) {
        var prevCat = '';
        var curCat = '';
        var curCatNoSpace = '';
        var resObj = response.data;
        var idx = 0;
        for (var i = 0; i < resObj.length; i = idx) {
          curCat = resObj[i].metric_cat;
          prevCat = curCat;
          curCatNoSpace = curCat.split(' ').join('_');
          var metNameLbl = [];
          var totOrAve = [];
          var recVal = [];
          var dtLbl = []; // for trend chart
          var recAvgVal = {};
          var didx = 0;
          var widx = 0;

          recVal[0] = [];
          for (var r = i; r < resObj.length; r++) {
            curCat = resObj[r].metric_cat;
            if (curCat !== prevCat) {
              idx = r; // finish this category and move to next category
              break;
            } else {
              idx++;
            }

            didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date));

            if (didx < 0 && resObj[r].c_date) {
              didx = dtLbl.length;
              dtLbl[didx] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date);
            }
            widx = metNameLbl.indexOf(resObj[r].metric_nm);
            if (widx < 0) {
              widx = metNameLbl.length;
              metNameLbl[widx] = resObj[r].metric_nm;
              recVal[widx] = [];
              totOrAve[widx] = resObj[r].period_display;
              recAvgVal[widx] = [];
            }
            if (_this12.aDay) {
              // show specefic data for the day in first graph in case of single date
              if (dtLbl[didx] === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this12.fromDate)) {
                recVal[widx][0] = resObj[r].metric_val;
              }
            } else {
              if (!recVal[widx][0]) {
                recVal[widx][0] = 0;
              }
              recVal[widx][0] += Number(resObj[r].metric_val);
            }
            // for trend
            if (!recAvgVal[widx][didx]) {
              recAvgVal[widx][didx] = 0;
            }
            recAvgVal[widx][didx] += resObj[r].metric_val;
          } // for every rec
          dtLbl.forEach(function (rec) {
            if (rec.length <= 0) {
              recAvgVal = {};
            }
          });
          // chart 1
          // data set
          var dsets = [];
          for (var c = 0; c < metNameLbl.length; c++) {
            // find avarage if this metric is configured to be displayed as average
            if (!_this12.aDay && totOrAve[c] === 'A') {
              recVal[c][0] /= dtLbl.length;
              recVal[c][0] = recVal[c][0].toFixed(0);
              metNameLbl[c] = metNameLbl[c] + ' (Avg)';
            } else if (!_this12.aDay) {
              metNameLbl[c] = metNameLbl[c] + ' (Tot)';
            }
            dsets[c] = {
              label: metNameLbl[c],
              backgroundColor: 'rgba(' + COLORS[c % 5] + ',0.4)',
              borderColor: 'rgba(' + COLORS[c % 5] + ',1)',
              data: recVal[c],
              fill: true
            };
          }
          // clear the content if any
          document.getElementById('div_other_' + curCatNoSpace).innerHTML = '<canvas id="chart_other_' + curCatNoSpace + '"></canvas>';
          var canvas = document.getElementById('chart_other_' + curCatNoSpace);
          var ctx = canvas.getContext('2d');
          _this12.tmpChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: [''],
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  formatter: function formatter(value) {
                    return value || '';
                  },
                  color: '#ffffff'
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          });
          // chart 2
          var dsets2 = [];
          for (var j = 0; j < metNameLbl.length; j++) {
            dsets2[j] = {
              label: metNameLbl[j],
              backgroundColor: 'rgba(' + COLORS[j % 5] + ',0.1)',
              borderColor: 'rgba(' + COLORS[j % 5] + ',1)',
              data: recAvgVal[j],
              fill: false
            };
          }
          if (_this12.enableTrend === true) {
            // clear the content if any
            document.getElementById('div_other_trend_' + curCatNoSpace).innerHTML = '<canvas id="chart_other_trend_' + curCatNoSpace + '"></canvas>';
            canvas = document.getElementById('chart_other_trend_' + curCatNoSpace);
            var ctx2 = canvas.getContext('2d');
            _this12.tmpChart2 = new Chart(ctx2, {
              type: 'line',
              data: {
                labels: dtLbl,
                datasets: dsets2
              },
              options: {
                plugins: {
                  datalabels: {
                    // hide datalabels for all datasets
                    display: false
                  }
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                  display: false
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true
                    }
                  }]
                }
              }
            });
          }
        }
      }).catch(function (err) {
        _this12.msg(err, 0);
      });
    },
    EnableTrend: function EnableTrend() {
      if (!this.enableTrend) {
        this.enableTrend = true;
      } else {
        this.enableTrend = false;
      }
      this.loadDailyDashboardSummary();
      this.$forceUpdate();
    },
    loadFacDailyUpdateAttachment: function loadFacDailyUpdateAttachment() {
      var _this13 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.aDay && !this.enableTrend ? this.fromDate : this.trendFrom,
          to_dt: this.aDay && !this.enableTrend ? this.toDate : this.trendTo
        }
      };
      this.lDailyUpdateAttach.fileUrls = [];
      this.lDailyUpdateAttach.files = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getAttachmentByCDate/', qry).then(function (response) {
        _this13.lDailyUpdateAttach.fileUrls = response.data;
        _this13.lDailyUpdateAttach.cat = _this13.lDailyUpdateAttach.cat || 'All';
        if (_this13.lDailyUpdateAttach.cat === 'All') {
          _this13.lDailyUpdateAttach.files = _this13.lDailyUpdateAttach.fileUrls;
        } else {
          _this13.lDailyUpdateAttach.files = _this13.lDailyUpdateAttach.fileUrls.filter(function (rec) {
            return rec.attach_cat_id === _this13.lDailyUpdateAttach.cat;
          });
        }
        _this13.$forceUpdate();
      }).catch(function (err) {
        _this13.msg(err.response.data, 0);
        _this13.lDailyUpdateAttach.fileUrls = [];
      });
    },
    loadCategoryImage: function loadCategoryImage(curcategory) {
      if (curcategory) {
        this.lDailyUpdateAttach.files = [];
        this.lDailyUpdateAttach.cat = curcategory;
        if (curcategory === 'All') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls;
        } else {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(function (rec) {
            return rec.attach_cat_id === curcategory;
          });
        }
        this.$forceUpdate();
      }
    },
    loadPhotoCat: function loadPhotoCat() {
      var _this14 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getPhotoCatByCommId/', qry).then(function (response) {
        _this14.photoCatChips = response.data;
        _this14.lDailyUpdateAttach.cat = _this14.photoCatChips[0].attach_cat_id;
      }).catch(function (err) {
        _this14.msg(err, true);
      });
    },
    loadTrendOverADayBasedOnPeriod: function loadTrendOverADayBasedOnPeriod(curChip, curType, curWatType) {
      if (this.aDay) {
        if (curWatType) {
          this.waterQualiltyType = curWatType;
        }
        // find the period based on selection
        this.enableTrendChip = curChip;
        this.fromTime = this.toTime = null;
        var curDate = new Date();
        if (curChip === 'Last 1 hr') {
          this.fromTime = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime(new Date(curDate.getTime() - 1000 * 60 * 60));
          this.toTime = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime(new Date(curDate.getTime()));
        } else if (curChip === '6 hrs') {
          this.fromTime = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime(new Date(curDate.getTime() - 1000 * 60 * 60 * 6));
          this.toTime = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime(new Date(curDate.getTime()));
        } else if (curChip === '12 hrs') {
          this.fromTime = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime(new Date(curDate.getTime() - 1000 * 60 * 60 * 12));
          this.toTime = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime(new Date(curDate.getTime()));
        } else {
          this.fromTime = '00:00:00';
          this.toTime = '23:59:59';
        }
        // if fromtime is greater than toTime
        if (this.fromTime > this.toTime) {
          this.fromTime = '00:00:00';
        }
        // common values for quality and level
        if (this.enableChip === 'Yesterday') {
          this.fromDt = new Date(curDate.setDate(curDate.getDate() - 1));
          this.toDt = this.fromDt;
        } else if (this.enableChip === 'Today') {
          this.fromDt = this.toDt = curDate;
        } else if (this.enableChip === 'Period') {
          this.fromDt = this.fromDate;
          this.toDt = this.toDate;
        }
        // refresh the Trend over a day graph
        if (curType === 'Quality') {
          this.showWaterQualityOverADay();
        } else if (curType === 'Level') {
          this.showWaterLevelOverADay();
        } else if (curType === 'Cons') {
          this.showWaterConsOverADay();
        }
      }
      if (curType === 'Power') {
        if (!this.aDay) {
          this.fromDt = this.fromDate;
          this.toDt = this.toDate;
        }
        this.showPowerConsPieChart();
      }
    },
    showWaterQualityOverADay: function showWaterQualityOverADay() {
      var _this15 = this;

      if (!this.waterQualiltyType) {
        this.waterQualiltyType = this.waterQualParamList[0];
      }
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.fromDt),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.toDt),
          from_time: this.fromTime,
          to_time: this.toTime
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWaterQualityBasedOnADay/', qry).then(function (response) {
        // retrive data from db and construct chart
        var resObj = response.data;
        var dtLbl = [];
        var watQualAvgVal = [];
        var paramNameLbl = [];
        var avgWaterLbl = [];
        var gd = 0;
        var apidx = 0;
        var custParamName = _this15.waterQualiltyType;
        // trend chart
        for (var i = 0; i < resObj.length; i++) {
          // for every rec
          paramNameLbl[i] = resObj[i].param_name;
          watQualAvgVal[i] = [];
          // for graph
          var lvl = resObj[i].value;
          for (var d = 0; d < lvl.length; d++) {
            if (lvl[d].val === '') {
              lvl[d].val = 0;
            }
            // worry about trend of only user chosen parameter
            if (custParamName === resObj[i].param_name) {
              var didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime12Hrs(lvl[d].c_date));
              if (didx < 0 && lvl[d].c_date) {
                dtLbl[gd] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime12Hrs(lvl[d].c_date);
                didx = gd++;
              }
              apidx = avgWaterLbl.indexOf(resObj[i].water_type);
              if (apidx < 0) {
                apidx = avgWaterLbl.length;
                avgWaterLbl[apidx] = resObj[i].water_type;
              }
              watQualAvgVal[apidx][didx] = Number(lvl[d].val);
            }
          }
        }
        for (var j = 0; j < paramNameLbl.length; j++) {
          // shorten the label
          if (paramNameLbl[j].length > 3) {
            paramNameLbl[j] = paramNameLbl[j].substring(0, 10);
          }
        }
        // chart 1
        // data set
        var watColor = 0;
        var dsets = [];
        for (i = 0; i < avgWaterLbl.length; i++) {
          watColor = _this15.waterTypeLebel.indexOf(avgWaterLbl[i]);
          dsets[i] = {
            label: avgWaterLbl[i],
            backgroundColor: 'rgba(' + COLORS[watColor] + ', 0.1)',
            borderColor: 'rgba(' + COLORS[watColor] + ', 1)',
            data: watQualAvgVal[i],
            fill: false
          };
        }

        // clear the content if any
        setTimeout(function () {
          document.getElementById('div_watqualoveradaytrend').innerHTML = '<canvas id="chart_watqualoveradaytrend"></canvas>';
          var canvas = document.getElementById('chart_watqualoveradaytrend');
          canvas.height += avgWaterLbl.length * 30;
          var ctx = canvas.getContext('2d');
          _this15.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom'
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }, 500);
        _this15.qualityTrendOverADay = true;
        _this15.$forceUpdate();
      }).catch(function (err) {
        _this15.msg(err, 0);
      });
    },
    showWaterLevelOverADay: function showWaterLevelOverADay() {
      var _this16 = this;

      if (!this.selectedStorageNmWithWaterLvl) {
        this.selectedStorageNmWithWaterLvl = this.storageNmListWithWaterLvl[0].storage_id;
      }
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.fromDt) + ' ' + this.fromTime,
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.toDt) + ' ' + this.toTime,
          storage_id: this.selectedStorageNmWithWaterLvl
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWaterLevelTrendOverAdayByStorageId/', qry).then(function (response) {
        // retrive data from db and construct chart
        var resObj = response.data;
        var dtLbl = [];
        var watLevelAvgVal = [];
        var avgStorageLbl = [];
        var gd = 0;
        var apidx = 0;
        var custStorageId = _this16.selectedStorageNmWithWaterLvl;
        _this16.watTankBattery = null;
        // trend chart
        for (var i = 0; i < resObj.length; i++) {
          watLevelAvgVal[i] = [];
          var lvl = resObj[i].levels[0];
          for (var d = 0; d < lvl.length; d++) {
            if (!lvl[d].water_level) {
              lvl[d].water_level = 0;
            }
            // worry about trend of only user chosen parameter
            if (custStorageId === resObj[i].storage_id) {
              if (lvl[d].dev_battery) {
                _this16.watTankBattery = lvl[d].dev_battery;
              }
              var didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime12Hrs(lvl[d].c_date));
              if (didx < 0 && lvl[d].c_date) {
                dtLbl[gd] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime12Hrs(lvl[d].c_date);
                didx = gd++;
              }
              apidx = avgStorageLbl.indexOf(resObj[i].storage_nm);
              if (apidx < 0) {
                apidx = avgStorageLbl.length;
                avgStorageLbl[apidx] = resObj[i].storage_nm;
              }
              watLevelAvgVal[apidx][didx] = Number(lvl[d].water_level);
            }
          }
        }
        // chart 1
        // data set
        var dsets = [];
        for (i = 0; i < avgStorageLbl.length; i++) {
          dsets[i] = {
            label: avgStorageLbl[i],
            backgroundColor: 'rgba(' + COLORS[1] + ',0.5)',
            borderColor: 'rgba(' + COLORS[0] + ', 1)',
            data: watLevelAvgVal[i],
            fill: true
          };
        }
        // clear the content if any
        setTimeout(function () {
          document.getElementById('div_watlvloveradaytrend').innerHTML = '<canvas id="chart_watlvloveradaytrend"></canvas>';
          var canvas = document.getElementById('chart_watlvloveradaytrend');
          canvas.height += avgStorageLbl.length * 30;
          var ctx = canvas.getContext('2d');
          _this16.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }, 500);
        _this16.lvlTrendOverADay = true;
        _this16.$forceUpdate();
      }).catch(function (err) {
        _this16.msg(err, 0);
      });
    },
    showPowerConsPieChart: function showPowerConsPieChart() {
      var _this17 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.fromDt),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.toDt)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getPowerMeterDailyRep/', qry).then(function (response) {
        var resObj = response.data;
        var areaLbl = [];
        var unitConsVal = [];
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          areaLbl[i] = resObj[i].area_covered;
          unitConsVal[i] = 0;
          if (!resObj[i].unit_cons) {
            resObj[i].unit_cons = 0;
          }
          unitConsVal[i] += Number(resObj[i].unit_cons);
        }
        var totZero = 0;
        for (i = 0; i < unitConsVal.length; i++) {
          if (unitConsVal[i] === 0) {
            totZero++;
          }
        }
        if (totZero === unitConsVal.length) {
          _this17.nodata = true;
        } else {
          _this17.nodata = false;
        }
        // chart 1
        // clear the content if any
        if (_this17.nodata) {
          setTimeout(function () {
            document.getElementById('div_powconstrendoveraday').innerHTML = 'No data available';
          }, 500);
          _this17.$forceUpdate();
        } else {
          setTimeout(function () {
            document.getElementById('div_powconstrendoveraday').innerHTML = '<canvas id="chart_powconstrendoveraday"></canvas>';
            var canvas = document.getElementById('chart_powconstrendoveraday');
            var ctx = canvas.getContext('2d');
            ctx.canvas.height = areaLbl.length * 18;
            ctx.canvas.width = areaLbl.length * 20;
            _this17.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: areaLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429', '#5f4170', '#4c646e'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function formatter(value) {
                      return value;
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Electricity Board (Units)'
                },
                legend: {
                  position: 'bottom'
                }
              }
            });
          }, 500);
        }
        _this17.showPowerConstrendOverADay = true;
        _this17.showPowerGensetPieChart();
        _this17.$forceUpdate();
      }).catch(function (err) {
        _this17.msg(err, 0);
      });
    },
    showPowerGensetPieChart: function showPowerGensetPieChart() {
      var _this18 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.fromDt),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.toDt)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getPowerGensetPieChartByCommId/', qry).then(function (response) {
        var resObj = response.data;
        var gensetLbl = [];
        var unitConsVal = [];
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          gensetLbl[i] = resObj[i].genset_nm;
          var unitVal = resObj[i].value;
          unitConsVal[i] = 0;
          for (var d = 0; d < unitVal.length; d++) {
            if (!unitVal[d].units_cons) {
              unitVal[d].units_cons = 0;
            }
            unitConsVal[i] += Number(unitVal[d].units_cons);
          }
        }
        var totZero = 0;
        for (i = 0; i < unitConsVal.length; i++) {
          if (unitConsVal[i] === 0) {
            totZero++;
          }
        }
        if (totZero === unitConsVal.length) {
          _this18.nodata = true;
        } else {
          _this18.nodata = false;
        }
        // chart 1
        // clear the content if any
        if (_this18.nodata) {
          setTimeout(function () {
            document.getElementById('div_powgensettrendoveraday').innerHTML = 'No data available';
          }, 500);
          _this18.$forceUpdate();
        } else {
          setTimeout(function () {
            document.getElementById('div_powgensettrendoveraday').innerHTML = '<canvas id="chart_powgensettrendoveraday"></canvas>';
            var canvas = document.getElementById('chart_powgensettrendoveraday');
            var ctx = canvas.getContext('2d');
            ctx.canvas.height = gensetLbl.length * 17;
            ctx.canvas.width = gensetLbl.length * 20;
            _this18.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: gensetLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function formatter(value) {
                      return value;
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Genset (Units)'
                },
                legend: {
                  position: 'bottom'
                }
              }
            });
          }, 500);
          _this18.$forceUpdate();
        }
      }).catch(function (err) {
        _this18.msg(err, 0);
      });
    },
    showWaterConsOverADay: function showWaterConsOverADay() {
      var _this19 = this;

      if (!this.selectedStorageNmWithWaterCons) {
        this.selectedStorageNmWithWaterCons = this.storageNmListWithWaterCons[0].storage_id;
      }
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.fromDt) + ' ' + this.fromTime,
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.toDt) + ' ' + this.toTime,
          storage_id: this.selectedStorageNmWithWaterCons
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWaterConsTrendOverAdayByStorageId/', qry).then(function (response) {
        // retrive data from db and construct chart
        var resObj = response.data;
        var dtLbl = [];
        var didx = [];
        var widx = [];
        var recAvgVal = {};
        var avgStorageLbl = [];
        var modeLbl = ['In-flow (KL)', 'Out-flow (KL)'];
        recAvgVal[0] = [];
        recAvgVal[1] = [];
        var cons = [];
        var custStorageId = _this19.selectedStorageNmWithWaterCons;
        // trend chart
        for (var r = 0; r < resObj.length; r++) {
          widx = avgStorageLbl.indexOf(resObj[r].storage_id);
          if (widx < 0) {
            widx = avgStorageLbl.length;
            avgStorageLbl[widx] = resObj[r].storage_nm.substring(0, 10);
          }
          cons = resObj[r].cons[0];
          for (var i = 0; i < cons.length; i++) {
            didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime12Hrs(cons[i].c_date));
            if (didx < 0 && cons[i].c_date) {
              didx = dtLbl.length;
              dtLbl[didx] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.getTime12Hrs(cons[i].c_date);
            }
            // worry about trend of only user chosen water type
            if (custStorageId === resObj[r].storage_id) {
              if (!recAvgVal[0][didx] || !recAvgVal[1][didx]) {
                recAvgVal[0][didx] = 0;
                recAvgVal[1][didx] = 0;
              }
              recAvgVal[0][didx] += cons[i].water_receipt;
              recAvgVal[1][didx] += cons[i].water_cons;
            }
          }
        } // for every rec
        // chart 1
        // data set
        var dsets = [];
        for (i = 0; i < modeLbl.length; i++) {
          dsets[i] = {
            label: modeLbl[i],
            backgroundColor: 'rgba(' + COLORS[i === 0 ? i + 2 : i + 3] + ',0.1)',
            borderColor: 'rgba(' + COLORS[i === 0 ? i + 2 : i + 3] + ',1)',
            data: recAvgVal[i],
            fill: true
          };
        }
        // clear the content if any
        setTimeout(function () {
          document.getElementById('div_watConsoveradaytrend').innerHTML = '<canvas id="chart_watConsoveradaytrend"></canvas>';
          var canvas = document.getElementById('chart_watConsoveradaytrend');
          canvas.height += avgStorageLbl.length * 30;
          var ctx = canvas.getContext('2d');
          _this19.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: dtLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  // hide datalabels for all datasets
                  display: false
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }, 500);
        _this19.consTrendOverADay = true;
        _this19.$forceUpdate();
      }).catch(function (err) {
        _this19.msg(err, 0);
      });
    },
    loadHygieneCat: function loadHygieneCat() {
      var _this20 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getSanCheckCatByCommId/', qry).then(function (response) {
        _this20.hygCats = response.data;
        _this20.loadHygiene();
      }).catch(function (err) {
        _this20.msg(err, true);
      });
    },
    loadHygiene: function loadHygiene() {
      var _this21 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: !this.aDay ? __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendFrom) : this.fromDate,
          to_dt: !this.aDay ? __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendFrom) : this.fromDate
        }
      };
      this.hygList = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getSanCheckByCommIdAndcDate/', qry).then(function (response) {
        _this21.hygList = response.data;
      }).catch(function (err) {
        _this21.msg(err, 0);
      });
    },
    loadIncidentClass: function loadIncidentClass() {
      var _this22 = this;

      this.incidentTypes = {};
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getIncidentClass/').then(function (response) {
        _this22.incidentTypes = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.unique(response.data.map(function (rec) {
          return rec.incident_type;
        })).sort();
        _this22.loadIncidents();
      }).catch(function (err) {
        _this22.msg(err, true);
      });
    },
    loadIncidents: function loadIncidents() {
      var _this23 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: !this.aDay ? __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendFrom) + ' 00:00:00' : this.fromDate + ' 00:00:00',
          to_dt: !this.aDay ? __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendFrom) + ' 23:59:59' : this.fromDate + ' 23:59:59'
        }
      };
      this.incidentList = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getIncidentListDailyRep/', qry).then(function (response) {
        if (response.data.length > 0) {
          _this23.incidentList = response.data;
        } else {
          if (_this23.incidentTypes.length > 0) {
            _this23.incidentTypes.forEach(function (rec) {
              _this23.incidentList.push({
                incident_type: rec,
                incident_class: 'NIL'
              });
            });
          }
        }
      }).catch(function (err) {
        _this23.msg(err, 0);
      });
    },
    loadRemark: function loadRemark() {
      var _this24 = this;

      var qry = {
        params: {
          from_dt: !this.aDay ? __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendFrom) : this.fromDate,
          to_dt: !this.aDay ? __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendFrom) : this.fromDate,
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getRemarksBasedOnCommId/', qry).then(function (response) {
        if (response.data.length > 0) {
          _this24.lReport.remark_attendance = response.data[0].remark_attendance;
          _this24.lReport.remark_water = response.data[0].remark_water;
          _this24.lReport.remark_power = response.data[0].remark_power;
        }
      }).catch(function (err) {
        _this24.msg(err, true);
      });
    },
    loadMoreRemark: function loadMoreRemark(curRemark) {
      var _this25 = this;

      var qry = {
        params: {
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendFrom),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendTo),
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.lReport.AttRemark = {};
      this.lReport.PowerRemark = {};
      this.lReport.WaterRemark = {};
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getRemarksBasedOnCommId/', qry).then(function (response) {
        _this25.lReport.AttRemark = response.data.filter(function (rec) {
          return rec.remark_attendance !== null;
        });
        _this25.lReport.PowerRemark = response.data.filter(function (rec) {
          return rec.remark_power !== null;
        });
        _this25.lReport.WaterRemark = response.data.filter(function (rec) {
          return rec.remark_water !== null;
        });
        _this25.showRemark = true;
        if (curRemark === 'Att') {
          _this25.lReport.remark = 'Att';
        } else if (curRemark === 'Power') {
          _this25.lReport.remark = 'Power';
        } else {
          _this25.lReport.remark = 'Water';
        }
      }).catch(function (err) {
        _this25.msg(err, true);
      });
    },
    loadSanityChecksMore: function loadSanityChecksMore() {
      var _this26 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendFrom),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.trendTo)
        }
      };
      this.sanList = [];
      this.lSan = {};
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getSanCheckByCommIdAndcDate/', qry).then(function (response) {
        _this26.sanList = response.data;
        _this26.lSan = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.unique(_this26.sanList.map(function (rec) {
          return __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(rec.c_date);
        }));
        _this26.showSanityChecks = true;
      }).catch(function (err) {
        _this26.msg(err, 0);
      });
    },
    loadIncidentMore: function loadIncidentMore() {
      var _this27 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.trendFrom,
          to_dt: this.trendTo
        }
      };
      this.lIncident = [];
      this.lInc = {};
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getIncidentListDailyRep/', qry).then(function (response) {
        _this27.lIncident = response.data;
        _this27.lInc = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.unique(_this27.lIncident.map(function (rec) {
          return __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(rec.created_on);
        }));
        _this27.showIncident = true;
      }).catch(function (err) {
        _this27.msg(err, 0);
      });
    },
    scrollToSection: function scrollToSection() {
      var element = this.$refs[this.sectionList[this.curSec++]];
      element.scrollIntoView();
      if (this.curSec === this.sectionList.length) {
        this.curSec = 0;
      }
    },
    enableAutoRef: function enableAutoRef() {
      this.isAutoRef = !this.isAutoRef;
      if (this.isAutoRef) {
        // set timer to refresh the data every min
        this.timer = setInterval(this.loadDashboardBasedOnPeriod, 60000);
        // scroll to
        this.secTimer = setInterval(this.scrollToSection, 10000);
      } else {
        clearInterval(this.timer);
        clearInterval(this.secTimer);
      }
    }
  }
});

/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(723)(true);
// imports


// module
exports.push([module.i, ".ccolor1{background-color:rgba(227,108,9,.8)}.ccolor2{background-color:rgba(49,133,155,.8)}.ccolor3{background-color:rgba(95,73,122,.8)}.ccolor4{background-color:rgba(118,146,60,.8)}.ccolor5{background-color:rgba(149,55,52,.8)}.ccolor6{background-color:rgba(54,96,146,.8)}.ccolor7{background-color:rgba(23,54,93,.8)}.ccolor8{background-color:rgba(73,68,41,.8)}", "", {"version":3,"sources":["/var/www/mysmwebapp/src/components/Facdash.vue"],"names":[],"mappings":"AACA,SACE,mCAAqC,CACtC,AACD,SACE,oCAAsC,CACvC,AACD,SACE,mCAAqC,CACtC,AACD,SACE,oCAAsC,CACvC,AACD,SACE,mCAAqC,CACtC,AACD,SACE,mCAAqC,CACtC,AACD,SACE,kCAAoC,CACrC,AACD,SACE,kCAAoC,CACrC","file":"Facdash.vue","sourcesContent":["\n.ccolor1 {\n  background-color:rgba(227,108,9,0.8);\n}\n.ccolor2 {\n  background-color:rgba(49,133,155,0.8);\n}\n.ccolor3 {\n  background-color:rgba(95,73,122,0.8);\n}\n.ccolor4 {\n  background-color:rgba(118,146,60,0.8);\n}\n.ccolor5 {\n  background-color:rgba(149,55,52,0.8);\n}\n.ccolor6 {\n  background-color:rgba(54,96,146,0.8);\n}\n.ccolor7 {\n  background-color:rgba(23,54,93,0.8);\n}\n.ccolor8 {\n  background-color:rgba(73,68,41,0.8);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(802);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(724)("28f6d0fe", content, true, {});

/***/ }),

/***/ 836:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pl-1 title grey lighten-4"
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs10": "",
      "sm8": ""
    }
  }, _vm._l((_vm.reportChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableChip === chip ? 'primary white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadDashboardBasedOnPeriod(chip)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(chip) + "\n                ")])], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pl-0 pr-1",
    attrs: {
      "xs2": "",
      "sm4": ""
    }
  }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('v-chip', {
    staticClass: "caption grey white--text",
    class: _vm.isAutoRef ? 'warning white--text' : '',
    attrs: {
      "small": "",
      "disabled": true
    },
    on: {
      "click": function($event) {
        return _vm.enableAutoRef()
      }
    }
  }, [_vm._v("AUTO REFRESH")]) : _vm._e(), _vm._v(" "), _c('v-chip', {
    staticClass: "caption grey white--text mr-0",
    class: _vm.enableTrend === true ? 'warning white--text' : '',
    attrs: {
      "small": "",
      "disabled": true
    },
    on: {
      "click": function($event) {
        return _vm.EnableTrend()
      }
    }
  }, [_vm._v("TREND")])], 1), _vm._v(" "), (_vm.enableChip === 'Period') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    staticClass: "ml-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgPeriodFrom",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.periodFrom
    },
    on: {
      "update:returnValue": function($event) {
        _vm.periodFrom = $event
      },
      "update:return-value": function($event) {
        _vm.periodFrom = $event
      }
    },
    model: {
      value: (_vm.dlgPeriodFrom),
      callback: function($$v) {
        _vm.dlgPeriodFrom = $$v
      },
      expression: "dlgPeriodFrom"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "From",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.periodFrom),
      callback: function($$v) {
        _vm.periodFrom = $$v
      },
      expression: "periodFrom"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.periodFrom),
      callback: function($$v) {
        _vm.periodFrom = $$v
      },
      expression: "periodFrom"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgPeriodFrom = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgPeriodFrom.save(_vm.periodFrom)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgPeriodTo",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.periodTo
    },
    on: {
      "update:returnValue": function($event) {
        _vm.periodTo = $event
      },
      "update:return-value": function($event) {
        _vm.periodTo = $event
      }
    },
    model: {
      value: (_vm.dlgPeriodTo),
      callback: function($$v) {
        _vm.dlgPeriodTo = $$v
      },
      expression: "dlgPeriodTo"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "To",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.periodTo),
      callback: function($$v) {
        _vm.periodTo = $$v
      },
      expression: "periodTo"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.periodTo),
      callback: function($$v) {
        _vm.periodTo = $$v
      },
      expression: "periodTo"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgPeriodTo = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgPeriodTo.save(_vm.periodTo)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadDashboardBasedOnPeriod('Period')
      }
    }
  }, [_vm._v("Go")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showUploadImage = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2"
  }, [_vm._v("insert_photo")]), _vm._v(_vm._s('Photos (' + _vm.lDailyUpdateAttach.fileUrls.length + ')'))], 1), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "text-decoration": "none",
      "color": "black"
    },
    attrs: {
      "to": {
        path: '/DailyReport/' + _vm.handy.formatDBDate(_vm.fromDate)
      }
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 accent",
    attrs: {
      "small": "",
      "disabled": !_vm.aDay
    }
  }, [_vm._v("GENERATE REPORT")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    ref: "bp_attendance",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pl-2 py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Attendance"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.showAttendanceSummary()
      }
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-1 pb-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "mx-auto": ""
    }
  }, [_c('div', [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_c('v-btn', {
    attrs: {
      "large": "",
      "fab": "",
      "color": "blue white--text title"
    },
    on: {
      "click": function($event) {
        return _vm.showAttendanceSummary()
      }
    }
  }, [_vm._v(_vm._s(_vm.lAtt.attAve + '%'))])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading px-1 mx-0",
    attrs: {
      "color": "rgba(227,108,9,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s((_vm.lAtt.tot_present ? _vm.lAtt.tot_present : 0) + '/' + _vm.lAtt.tot_staff))])], 1), _vm._v(" "), _c('div', [_vm._v("Present")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading px-1 mx-0",
    attrs: {
      "color": "rgba(149,55,52,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.lAtt.tot_wo ? _vm.lAtt.tot_wo : 0))])], 1), _vm._v(" "), _c('div', [_vm._v("WO")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading px-1 mx-0",
    attrs: {
      "color": "rgba(118,146,60,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.lAtt.tot_ot ? _vm.lAtt.tot_ot : 0))])], 1), _vm._v(" "), _c('div', [_vm._v("Sby/OT")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading px-1 mx-0",
    attrs: {
      "color": "rgba(95,73,122,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s((_vm.lAtt.tot_absent || _vm.lAtt.tot_leave) ? (_vm.lAtt.tot_absent + _vm.lAtt.tot_leave) : 0))])], 1), _vm._v(" "), _c('div', [_vm._v("Leave/Ab")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading px-1",
    attrs: {
      "color": "rgba(54,96,146,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.lAtt.tot_pend || 0))])], 1), _vm._v(" "), _c('div', [_vm._v("Pending")])]), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                          TREND\n                        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_attend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_attend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    class: _vm.aDay ? 'caption pl-1' : 'caption pl-1 pt-3'
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_attendance ? _vm.lReport.remark_attendance : 'NA') + "\n                ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-center",
    attrs: {
      "xs1": ""
    }
  }, [(!_vm.aDay) ? _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadMoreRemark('Att')
      }
    }
  }, [_vm._v("More")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    ref: "bp_water",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Water Management"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pr-0 py-0"
  }, [_c('span', [_vm._v("Water Quality" + _vm._s(!_vm.aDay ? ' (Average)' : ''))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.aDay
    },
    on: {
      "click": function($event) {
        _vm.$vuetify.breakpoint.smAndUp ? _vm.loadTrendOverADayBasedOnPeriod('6 hrs', 'Quality') : _vm.loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Quality')
      }
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.watQualHead,
      "items": _vm.watList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              _vm.$vuetify.breakpoint.smAndUp ? _vm.loadTrendOverADayBasedOnPeriod('6 hrs', 'Quality', props.item.param_name) : _vm.loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Quality', props.item.param_name)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.param_name + props.item.param_value))]), _vm._v(" "), _vm._l((props.item.waterQualTypeValue), function(watQualVal, i) {
          return _c('td', {
            key: i,
            class: 'pa-2 ' + (watQualVal.val && (watQualVal.val < props.item.std_val_min || watQualVal.val > props.item.std_val_max) ? 'red white--text' : (watQualVal.val ? 'green lighten-3' : ''))
          }, [_vm._v("\n                              " + _vm._s(watQualVal.val ? watQualVal.val : '-') + "\n                            ")])
        })], 2)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                          TREND\n                        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-2 pt-0",
    attrs: {
      "xs8": "",
      "sm4": "",
      "mx-auto": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.waterQualParamList,
      "label": "Parameter",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadWaterQualChart()
      }
    },
    model: {
      value: (_vm.waterQualType),
      callback: function($$v) {
        _vm.waterQualType = $$v
      },
      expression: "waterQualType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watqualtrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watqualtrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pb-0 pr-0 pt-2"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-0 pb-0 pt-2 mt-1",
    attrs: {
      "xs10": ""
    }
  }, [_c('span', [_vm._v("Water Level" + _vm._s(!_vm.aDay ? ' (Average)' : ''))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.aDay
    },
    on: {
      "click": function($event) {
        _vm.$vuetify.breakpoint.smAndUp ? _vm.loadTrendOverADayBasedOnPeriod('6 hrs', 'Level') : _vm.loadTrendOverADayBasedOnPeriod('Last 1 hr', 'Level')
      }
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-y": "scroll",
      "height": "210px",
      "padding": "1rem 1rem 1rem 0px"
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watlvl"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watlvl"
    }
  })])])]), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                          TREND\n                        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "222px"
    },
    attrs: {
      "id": "div_watlvltrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watlvltrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pb-0 pr-0 pt-2"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-0 pb-0 pt-2 mt-1",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('span', [_vm._v("Water " + _vm._s(!_vm.aDay ? 'Cons. (Total)' : 'Consumption'))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, _vm._l((_vm.consumptionChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: (_vm.choosenType === chip ? 'caption primary white--text' : 'caption'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadWaterConsumptionBasedonChip(chip)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(chip) + "\n                              ")])], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.aDay
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('6 hrs', 'Cons')
      }
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0 pr-0"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "py-2 text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "white--text title px-1 py-1",
    attrs: {
      "color": "rgba(149,55,52,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.consumedVal > 0 ? (_vm.consumedVal.toFixed(2) + ' KL') : 'NA'))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-y": "scroll",
      "height": "140px",
      "padding": "1rem 1rem 1rem 0px"
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watcons"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watcons"
    }
  })])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(!_vm.$vuetify.breakpoint.smAndUp) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "pt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2"
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', [_c('b', [_vm._v("Water Sources (KL)")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2"
  }, [_c('v-divider')], 1)], 1)], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b', [_vm._v("SOURCES (KL)")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.domWatList), function(wat, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "py-2 pl-2",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-left",
      attrs: {
        "xs9": ""
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(wat.water_type))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-left title",
      attrs: {
        "xs3": ""
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(wat.water_receipt ? wat.water_receipt.toFixed(2) : 0))])])], 1)], 1)
  }), 1)], 1), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                          TREND\n                        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-3 pt-0",
    attrs: {
      "xs8": "",
      "sm6": "",
      "mx-auto": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.waterConsTypeList,
      "label": "Storage",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadWaterConsChart()
      }
    },
    model: {
      value: (_vm.waterConsType),
      callback: function($$v) {
        _vm.waterConsType = $$v
      },
      expression: "waterConsType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watconstrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watconstrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    class: _vm.aDay ? 'caption pl-1' : 'caption pl-1 pt-3'
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_water ? _vm.lReport.remark_water : 'NA') + "\n            ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-center",
    attrs: {
      "xs1": ""
    }
  }, [(!_vm.aDay) ? _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadMoreRemark('Water')
      }
    }
  }, [_vm._v("More")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    ref: "bp_power",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Power Management"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pa-2"
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v("\n                  Power Consumption" + _vm._s(!_vm.aDay ? ' (Total)' : '') + "\n                ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('', 'Power')
      }
    }
  }, [_c('v-icon', [_vm._v("pie_chart")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    style: (_vm.$vuetify.breakpoint.smAndUp ? 'min-height: 150px;' : ''),
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "xs6": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('', 'Power')
      }
    }
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text title px-1 py-1",
    attrs: {
      "color": "rgba(95,73,122,0.8)",
      "disabled": ""
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('', 'Power')
      }
    }
  }, [_vm._v(_vm._s(_vm.powCons ? _vm.powCons + ' units' : 'NA'))])])], 1), _vm._v(" "), _c('div', [_vm._v("Electricity Board")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "xs6": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('', 'Power')
      }
    }
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text title px-1 py-1",
    attrs: {
      "color": "rgba(149,55,52,0.8)",
      "disabled": ""
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.loadTrendOverADayBasedOnPeriod('', 'Power')
      }
    }
  }, [_vm._v(_vm._s(_vm.genCons ? _vm.genCons + ' units' : 'NA'))])])], 1), _vm._v(" "), _c('div', [_vm._v("Genset")])])], 1)], 1), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                        TREND\n                      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_powconstrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powconstrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pa-2"
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v("\n                  Diesel Consumption & Level\n                ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-0",
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading pa-1",
    attrs: {
      "color": "rgba(95,73,122,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.diCons !== 'NaN' ? _vm.diCons + ' L' : '0 L'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-1"
  }, [_vm._v("Purchased" + _vm._s(!_vm.aDay ? ' (Total)' : ''))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-0",
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('div', [_c('v-chip', {
    staticClass: "white--text subheading pa-1",
    attrs: {
      "color": "rgba(149,55,52,0.8)",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.diStock !== 'NaN' ? _vm.diStock + ' L' : '0 L'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-2"
  }, [_vm._v("Stock" + _vm._s(!_vm.aDay ? ' (Average)' : ''))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_dicons"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_dicons"
    }
  })])]), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                        TREND\n                      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_diconstrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_diconstrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    class: _vm.aDay ? 'caption pl-1' : 'caption pl-1 pt-3'
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_power ? _vm.lReport.remark_power : 'NA') + "\n            ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 text-xs-center",
    attrs: {
      "xs1": ""
    }
  }, [(!_vm.aDay) ? _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadMoreRemark('Power')
      }
    }
  }, [_vm._v("More")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Waste Management" + _vm._s(!_vm.aDay ? ' (Total)' : '')), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_waste"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_waste"
    }
  })])]), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption primary--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n                TREND\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2 primary"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_wastetrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_wastetrend"
    }
  })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    ref: "bp_sanity",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Hygiene Management / Sanity Checks"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', {
    class: !_vm.aDay ? 'pa-0' : ''
  }, [_c('v-layout', {
    staticClass: "text-xs-left",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.aDay) ? _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadSanityChecksMore()
      }
    }
  }, [_vm._v("Click here to see the list for given period")])], 1) : _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.hygCats), function(cat, n) {
    return _c('v-flex', {
      key: n,
      class: n > 0 ? 'pa-0 mt-1' : 'pa-0',
      staticStyle: {
        "border": "1px solid black"
      },
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "text-xs-left pa-2 primary white--text font"
    }, [_vm._v(_vm._s(cat.check_cat))]), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.hygList.filter(function (rec) { return rec.check_cat === cat.check_cat; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticClass: "pr-0",
            staticStyle: {
              "width": "400px"
            }
          }, [_vm._v(_vm._s(props.item.check_desc))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "width": "50px"
            }
          }, [_c('v-checkbox', {
            staticClass: "pt-2",
            attrs: {
              "hide-details": "",
              "readonly": ""
            },
            model: {
              value: (props.item.check_value),
              callback: function($$v) {
                _vm.$set(props.item, "check_value", $$v)
              },
              expression: "props.item.check_value"
            }
          })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.remark ? props.item.remark : ''))])])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Incidents"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', {
    class: !_vm.aDay ? 'pa-0' : ''
  }, [_c('v-layout', {
    staticClass: "text-xs-left",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.aDay) ? _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadIncidentMore()
      }
    }
  }, [_vm._v("Click here to see the list for given period")])], 1) : _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.incidentTypes), function(incident, n) {
    return _c('v-flex', {
      key: n,
      class: n > 0 ? 'pa-0 mt-1' : 'pa-0',
      staticStyle: {
        "border": "1px solid black"
      },
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "text-xs-left pa-2 primary white--text font"
    }, [_vm._v(_vm._s(incident))]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.incidentList.filter(function (rec) { return rec.incident_type === incident; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticClass: "font",
            staticStyle: {
              "width": "315px"
            }
          }, [_vm._v(_vm._s(props.item.incident_class))]), _vm._v(" "), _c('td', {
            staticClass: "font"
          }, [_vm._v(_vm._s(props.item.incident_on ? (_vm.handy.formatDate(props.item.incident_on) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + _vm.handy.formatDate(props.item.incident_end) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_end) : '') + ' - ' + props.item.incident_desc) : ''))])])]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.metricCat.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Custom Metrics"), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.metricCat), function(cat, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', {
      staticClass: "title"
    }, [_c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                " + _vm._s(cat) + "\n              ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
      staticClass: "text-xs-center",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      attrs: {
        "id": 'div_other_' + cat.split(' ').join('_')
      }
    }, [_c('canvas', {
      attrs: {
        "id": 'chart_other_' + cat.split(' ').join('_')
      }
    })])]), _vm._v(" "), (_vm.enableTrend === true) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs5": ""
      }
    }, [_c('v-divider', {
      staticClass: "mt-2 primary"
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "caption primary--text",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v("\n                      TREND\n                    ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs5": ""
      }
    }, [_c('v-divider', {
      staticClass: "mt-2 primary"
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      attrs: {
        "id": 'div_other_trend_' + cat.split(' ').join('_')
      }
    }, [_c('canvas', {
      attrs: {
        "id": 'chart_other_trend_' + cat.split(' ').join('_')
      }
    })])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "900px"
    },
    model: {
      value: (_vm.showUploadImage),
      callback: function($$v) {
        _vm.showUploadImage = $$v
      },
      expression: "showUploadImage"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title grey lighten-4"
  }, [_c('div', [_vm._v("Photos "), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showUploadImage = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-2",
    attrs: {
      "xs12": ""
    }
  }, [_vm._l((_vm.photoCatChips), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "color": _vm.lDailyUpdateAttach.cat === chip.attach_cat_id ? 'primary white--text' : ''
      },
      on: {
        "click": function($event) {
          return _vm.loadCategoryImage(chip.attach_cat_id)
        }
      }
    }, [_vm._v("  " + _vm._s(chip.attach_cat_name + (_vm.lDailyUpdateAttach.fileUrls ? (_vm.lDailyUpdateAttach.fileUrls && _vm.lDailyUpdateAttach.fileUrls.filter(function (rec) { return rec.attach_cat_id === chip.attach_cat_id; }).length ? (' (' + _vm.lDailyUpdateAttach.fileUrls.filter(function (rec) { return rec.attach_cat_id === chip.attach_cat_id; }).length + ')') : '') : '')))])], 1)
  }), _vm._v(" "), _c('v-chip', {
    attrs: {
      "color": _vm.lDailyUpdateAttach.cat === 'All' ? 'primary white--text' : ''
    },
    on: {
      "click": function($event) {
        return _vm.loadCategoryImage('All')
      }
    }
  }, [_vm._v("All (" + _vm._s(_vm.lDailyUpdateAttach.fileUrls && _vm.lDailyUpdateAttach.fileUrls.length) + ")")])], 2)], 1), _vm._v(" "), _c('v-card-text', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.lDailyUpdateAttach.files && _vm.lDailyUpdateAttach.files.length > 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lDailyUpdateAttach.files), function(file, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pa-1 text-xs-center",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-card-media', {
      staticClass: "black--text caption",
      attrs: {
        "height": "210px",
        "src": _vm.config.FILE_URL(file.file_url)
      }
    }, [_c('div', {
      staticClass: "white--text",
      staticStyle: {
        "background-color": "rgba(125, 125, 125, 0.5)"
      }
    }, [_vm._v(_vm._s(_vm.handy.formatDBDateTime(file.attach_timestamp))), _c('br'), _vm._v("by " + _vm._s(file.user_name))]), _vm._v(" "), (file.notes) ? _c('div', {
      staticClass: "text-xs-center white--text",
      staticStyle: {
        "position": "absolute",
        "bottom": "0px",
        "width": "100%",
        "background-color": "rgba(0, 0, 255, 0.5)"
      }
    }, [_vm._v("\n                " + _vm._s(file.notes) + "\n              ")]) : _vm._e()])], 1)
  }), 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', [_c('div', {
    staticClass: "pa-2"
  }, [_vm._v("No photos are available.")])])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "850px"
    },
    model: {
      value: (_vm.showSummary),
      callback: function($$v) {
        _vm.showSummary = $$v
      },
      expression: "showSummary"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Attendance Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSummary = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.repHeadSm : _vm.repHead,
      "items": _vm.attReport,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0"
        }, [_vm._v(_vm._s(props.item.tot_present))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_wo))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_holiday))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_ot))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_leave))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_absent))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "red--text pa-0"
        }, [_vm._v(_vm._s(props.item.tot_pend))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "960px"
    },
    model: {
      value: (_vm.qualityTrendOverADay),
      callback: function($$v) {
        _vm.qualityTrendOverADay = $$v
      },
      expression: "qualityTrendOverADay"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Trend over a day\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.qualityTrendOverADay = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    class: _vm.$vuetify.breakpoint.smAndUp ? '' : 'pt-0 pb-2',
    attrs: {
      "items": _vm.waterQualParamList,
      "hide-details": "",
      "solo": ""
    },
    on: {
      "change": function($event) {
        return _vm.showWaterQualityOverADay()
      }
    },
    model: {
      value: (_vm.waterQualiltyType),
      callback: function($$v) {
        _vm.waterQualiltyType = $$v
      },
      expression: "waterQualiltyType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'text-xs-right' : 'text-xs-center',
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, _vm._l((_vm.trendChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableTrendChip === chip ? 'primary white--text' : '',
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadTrendOverADayBasedOnPeriod(chip, 'Quality')
        }
      }
    }, [_vm._v("\n                " + _vm._s(chip) + "\n              ")])], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watqualoveradaytrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watqualoveradaytrend"
    }
  })])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "960px"
    },
    model: {
      value: (_vm.lvlTrendOverADay),
      callback: function($$v) {
        _vm.lvlTrendOverADay = $$v
      },
      expression: "lvlTrendOverADay"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Trend over a day\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lvlTrendOverADay = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-select', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'pt-0' : 'pt-0 pb-2',
    attrs: {
      "items": _vm.storageNmListWithWaterLvl,
      "item-value": "storage_id",
      "item-text": "storage_nm",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.showWaterLevelOverADay()
      }
    },
    model: {
      value: (_vm.selectedStorageNmWithWaterLvl),
      callback: function($$v) {
        _vm.selectedStorageNmWithWaterLvl = $$v
      },
      expression: "selectedStorageNmWithWaterLvl"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'text-xs-right' : 'text-xs-center',
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, _vm._l((_vm.trendChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableTrendChip === chip ? 'primary white--text' : '',
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadTrendOverADayBasedOnPeriod(chip, 'Level')
        }
      }
    }, [_vm._v("\n                " + _vm._s(chip) + "\n              ")])], 1)
  }), 0), _vm._v(" "), (_vm.watTankBattery) ? _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [(_vm.watTankBattery > 20) ? _c('v-icon', {
    staticClass: "mt-2",
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "color": "#00d455"
    }
  }, [_vm._v("battery_full")]) : _c('v-icon', {
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "color": "error"
    }
  }, [_vm._v("battery_alert")])], 1), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.watTankBattery + '%'))])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watlvloveradaytrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watlvloveradaytrend"
    }
  })])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "960px"
    },
    model: {
      value: (_vm.consTrendOverADay),
      callback: function($$v) {
        _vm.consTrendOverADay = $$v
      },
      expression: "consTrendOverADay"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Trend over a day\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.consTrendOverADay = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-select', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'pt-0' : 'pt-0 pb-2',
    attrs: {
      "items": _vm.storageNmListWithWaterCons,
      "item-value": "storage_id",
      "item-text": "storage_nm",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.showWaterConsOverADay()
      }
    },
    model: {
      value: (_vm.selectedStorageNmWithWaterCons),
      callback: function($$v) {
        _vm.selectedStorageNmWithWaterCons = $$v
      },
      expression: "selectedStorageNmWithWaterCons"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'text-xs-right' : 'text-xs-center',
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, _vm._l((_vm.waterConsTrendChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableTrendChip === chip ? 'primary white--text' : '',
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadTrendOverADayBasedOnPeriod(chip, 'Cons')
        }
      }
    }, [_vm._v("\n                " + _vm._s(chip) + "\n              ")])], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watConsoveradaytrend"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watConsoveradaytrend"
    }
  })])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "960px"
    },
    model: {
      value: (_vm.showPowerConstrendOverADay),
      callback: function($$v) {
        _vm.showPowerConstrendOverADay = $$v
      },
      expression: "showPowerConstrendOverADay"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Power cons. breakup\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPowerConstrendOverADay = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_powconstrendoveraday"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powconstrendoveraday"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_powgensettrendoveraday"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powgensettrendoveraday"
    }
  })])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scroll": "",
      "max-width": "750"
    },
    model: {
      value: (_vm.showSanityChecks),
      callback: function($$v) {
        _vm.showSanityChecks = $$v
      },
      expression: "showSanityChecks"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Hygiene Management / Sanity Checks\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSanityChecks = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', _vm._l((_vm.lSan), function(item, n) {
    return _c('v-flex', {
      key: n,
      class: n > 0 ? 'mt-2' : '',
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "pa-2 primary white--text"
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-1",
      attrs: {
        "headers": _vm.sanHeads,
        "items": _vm.sanList.filter(function (rec) { return _vm.handy.formatDate(rec.c_date) === item; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.check_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.check_desc))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "width": "340px"
            }
          }, [_vm._v(_vm._s(props.item.remark ? props.item.remark : '-'))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-right",
            staticStyle: {
              "width": "50px"
            }
          }, [_c('v-checkbox', {
            staticClass: "pt-2",
            attrs: {
              "hide-details": "",
              "readonly": ""
            },
            model: {
              value: (props.item.check_value),
              callback: function($$v) {
                _vm.$set(props.item, "check_value", $$v)
              },
              expression: "props.item.check_value"
            }
          })], 1)])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scroll": "",
      "max-width": "750"
    },
    model: {
      value: (_vm.showIncident),
      callback: function($$v) {
        _vm.showIncident = $$v
      },
      expression: "showIncident"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("\n          Incidents\n          "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showIncident = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', _vm._l((_vm.lInc), function(item, n) {
    return _c('v-flex', {
      key: n,
      class: n > 0 ? 'mt-2' : '',
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "pa-2 primary white--text"
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-1",
      attrs: {
        "headers": _vm.incHeads,
        "items": _vm.lIncident.filter(function (rec) { return _vm.handy.formatDate(rec.created_on) === item; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.incident_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_class))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_desc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_on ? (_vm.handy.formatDate(props.item.incident_on) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + _vm.handy.formatDate(props.item.incident_end) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_end) : '')) : ''))])])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scroll": "",
      "max-width": "750"
    },
    model: {
      value: (_vm.showRemark),
      callback: function($$v) {
        _vm.showRemark = $$v
      },
      expression: "showRemark"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 pr-0 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_c('span', [_vm._v(_vm._s(_vm.lReport.remark === 'Att' ? 'Attendance Remarks' : _vm.lReport.remark === 'Power' ? 'Power Remarks' : _vm.lReport.remark === 'Water' ? 'Water Remarks' : ''))]), _vm._v(" "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.chosenPeriod))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showRemark = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.AttHeads,
      "items": _vm.lReport.remark === 'Att' ? _vm.lReport.AttRemark : _vm.lReport.remark === 'Power' ? _vm.lReport.PowerRemark : _vm.lReport.remark === 'Water' ? _vm.lReport.WaterRemark : '',
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticStyle: {
            "width": "150px"
          }
        }, [_vm._v(_vm._s(_vm.handy.formatDate(props.item.c_date)))]), _vm._v(" "), (_vm.lReport.remark === 'Att') ? _c('td', [_vm._v(_vm._s(props.item.remark_attendance ? props.item.remark_attendance : '-'))]) : _vm._e(), _vm._v(" "), (_vm.lReport.remark === 'Power') ? _c('td', [_vm._v(_vm._s(props.item.remark_power ? props.item.remark_power : '-'))]) : _vm._e(), _vm._v(" "), (_vm.lReport.remark === 'Water') ? _c('td', [_vm._v(_vm._s(props.item.remark_water ? props.item.remark_water : '-'))]) : _vm._e()])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/37.686e2c0f888491a02b20.js